export default __webpack_public_path__ + "static/getStart-ab24b83fb855bf41edf1e84f94206555.png";